import { Component, OnInit, Input } from '@angular/core';
import { ResidentialService } from '../../residential.service';
import { _ } from 'underscore';
import { sqft_sizes } from '../../../../../assets/sqft.sizes';
import {
  trigger,
  state,
  style,
  animate,
  transition,
  group
} from '@angular/animations';
import { isEmpty } from 'rxjs/operators';

@Component({
  selector: 'app-r-q11',
  templateUrl: './r-q11.component.html',
  styleUrls: ['./r-q11.component.css', '../residential-question.component.css'],
  animations: [
    trigger('flyInOut', [
      state('in', style({
        transform: 'translateX(0)', opacity: 1
      })),
      transition('void => *', [
        style({transform: 'translateX(100px)', opacity: 0 }),
        group([
          animate('0.4s 0.1s ease', style({
            transform: 'translateX(0)',
          })),
          animate('0.4s ease', style({
            opacity: 1
          }))
        ])
      ]),
      transition('* => void', [
        group([
          animate('0.4s ease', style({
            transform: 'translateX(50px)',
          })),
          animate('0.4s 0.2s ease', style({
            opacity: 0
          }))
        ])
      ])
    ]),
    trigger('flyOut', [
      state('out', style({ transform: 'translateX(0)' })),
      transition('void => *', [
        style({ transform: 'translateX(-100%)' }),
        animate(100)
      ]),
      transition('* => void', [
        animate(100, style({ transform: 'translateX(100%)' }))
      ])
    ]),
    trigger('flyOutans', [
      state('in', style({ transform: 'translateX(0)' })),
      transition('void => *', [
        style({ transform: 'translateX(100%)' }),
        animate(100)
      ]),
      transition('* => void', [
        animate(100, style({ transform: 'translateX(0%)' }))
      ])
    ])
  ]
})
export class RQ11Component implements OnInit {

  @Input() data: any;
  sqft_size;
  question;
  questions;
  userResponses = [];
  index;
  questionObj;
  showTip = true;
  showbutton = true;
  property;
  sqfts;
  messagetype;
  user_bot = false;
  deviceWidth;
  timer;

  constructor(private residentialService: ResidentialService) {
    this.questions = this.residentialService.getQues();
    this.userResponses = this.residentialService.userResponse.userResponses;
    this.property = this.residentialService.property;
    this.sqfts = sqft_sizes.sqfts;
    this.deviceWidth = this.residentialService.deviceWidth;
  }

  goNext() {
    if (this.timer) {
      clearTimeout(this.timer);
    }
    if (this.deviceWidth < 768) {
      this.timer = setTimeout(() => {
        this.next();
      }, 0);
    }
  }

  ngOnInit() {
    this.residentialService.currentId = this.data;
    // check the flow is renewal
    if (this.residentialService.questionFlowType === 'renewal') {
      this.residentialService.messageService({ 'nextId': '0014' });
    }
    for (let i = 0; i < this.questions.length; i++) {
      if (this.questions[i]._id === this.data) {
        this.question = this.questions[i].res_question;
        this.questionObj = this.questions[i];
        this.index = i;
      }
    }
    if (!_.isEmpty(this.property)) {
      if (this.property === 'Apartment or condominium') {
        this.question = this.question.replace('home', 'apartment');
      }
    }
    if (this.userResponses.length > 0 && !_.isEmpty(this.questionObj)) {
      const obj = _.findWhere(this.userResponses, { 'res_question_id': this.questionObj._id });
      if (!_.isEmpty(obj)) {
        this.sqft_size = obj.fieldValue;
        this.user_bot = true;
        if (this.deviceWidth < 768) {
          this.goNext();
        }
      }
    }
    if (!_.isEmpty(this.sqft_size)) {
      this.showTip = false;
    }
    this.messagetype = this.residentialService.messervicetype;

    if(_.isEmpty(this.sqft_size))
    {
      this.showbutton = false;
    }
  }

  enableButton() {
    if (this.sqft_size === null || this.sqft_size === undefined || this.sqft_size === '') {
      this.user_bot = false;
    } else {
      this.user_bot = true;
    }
  }

  checkEmpty() {
    if (this.sqft_size === null) {
      const Obj = {
        'res_question_id': this.data, 'fieldName': 'sqft_size', 'fieldValue': this.sqft_size, 'mappedValue': ''
      };
      this.residentialService.updateResponses(Obj);
    }
  }

  next() {
    const input_value = this.sqft_size;
    // this.user_bot = true;
    let sqft_mapped_value = '';
    if (this.sqft_size === '' || this.sqft_size === undefined || this.sqft_size === null) {
      // console.log.log(this.sqft_size);
      // alert('Select the Sqft');
    } else {
      this.user_bot = true;
      _.each(this.sqfts, function (size_value) {
        const sizes = size_value.split('-');
        if (sqft_mapped_value === '') {
          if (sizes.length === 2) {
            if (Number(input_value) >= Number(sizes[0]) && Number(input_value) <= Number(sizes[1])) {
              sqft_mapped_value = size_value;
            }
          } else if (sizes.length === 1) {
            sqft_mapped_value = size_value;
          }
        }
      });

      const Obj = {
        'res_question_id': this.data, 'fieldName': 'sqft_size', 'fieldValue': this.sqft_size, 'mappedValue': sqft_mapped_value
      };
      this.residentialService.updateResponses(Obj);
      document.getElementById('sqft_s').blur();
      this.residentialService.messageService({ 'currentId': this.data });
    }
  }

}
